import { render, staticRenderFns } from "./CustomInfiniteScroll.vue?vue&type=template&id=0fb279e6&scoped=true"
import script from "./CustomInfiniteScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomInfiniteScroll.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CustomInfiniteScroll.vue?vue&type=style&index=0&id=0fb279e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb279e6",
  null
  
)

export default component.exports